import axios from '../../axios'

export default {
  getPossObjectCodes: function () {
    return axios.get('possobjectcodes')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/PossObjectCodesApi.js